import React from 'react';
import '../CSS/InfoBox.css';

const InfoBox = ({ isHackerTheme }) => {
  const handleDownloadCV = () => {
    // Add your CV download logic here
    console.log('Downloading CV...');
  };

  const handleDownloadResume = () => {
    // Add your Resume download logic here
    console.log('Downloading Resume...');
  };

  return (
    <div className={`info-card ${isHackerTheme ? 'hacker-theme' : ''}`}>
      
      <div className="info-body">
        <div className="info-content">
          <div className="aboutParagraphs ">
            <p>
             I'm Udana Senanayake, an active Developer and Cybersecurity Enthusiast from Sri Lanka, passionate about creating secure, scalable, and impactful digital experiences that merge performance, user trust, and cutting-edge innovation in meaningful ways.
            </p>   
          </div>
          {/* Download Buttons */}
          <div className="download-buttons">
            <button className="download-btn cv-btn" onClick={handleDownloadCV}>
              <span className="btn-icon"></span>
               CV
            </button>
            <button className="download-btn resume-btn" onClick={handleDownloadResume}>
              <span className="btn-icon"></span>
               Resume
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoBox;